'use strict'

// requires jQuery on page
export default function () {
  // add class hooks for images within WYSWIYG areas
  $('.wysiwyg-content p img, .wysiwyg-content p picture').closest('p').addClass('p-containsimage')
}
